module.exports = __webpack_public_path__ + "img/symbol_8.d3194002.png";